function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var NavalMovementTemplate = require('./naval-movement.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var NavalMovementOverlay = /*#__PURE__*/function () {
  function NavalMovementOverlay(app, mod) {
    _classCallCheck(this, NavalMovementOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(NavalMovementOverlay, [{
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.visible = true;
      this.overlay.show(NavalMovementTemplate());
      this.attachEvents(mycallback);
    }
  }, {
    key: "selectUnits",
    value: function selectUnits() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var html = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var obj = null;
      obj = document.querySelector('.naval-movement-overlay .origin .sstatus');
      if (!obj) {
        return;
      }
      obj.innerHTML = msg;
      obj = document.querySelector('.naval-movement-overlay .origin .scontrols');
      if (!obj) {
        return;
      }
      obj.innerHTML = html;
    }
  }, {
    key: "hideDestination",
    value: function hideDestination() {
      var obj = document.querySelector('.naval-movement-overlay .destination .dcontrols');
      if (!obj) {
        return;
      }
      obj.innerHTML = '';
    }
  }, {
    key: "selectDestination",
    value: function selectDestination() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var html = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var obj = document.querySelector('.naval-movement-overlay .destination .dcontrols');
      if (!obj) {
        return;
      }
      obj.innerHTML = html;
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var mycallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    }
  }]);
}();
module.exports = NavalMovementOverlay;